export default class Cliente {
  constructor(
    id_cliente = null,
    numero_cliente = '',
    tipo_pessoa = 'F',
    razao_social = '',
    nome_fantasia = '',
    cpf_cnpj = '',
    rg_ie = '',
    inscricao_municipal = '',
    // endereco = {
    //   logradouro: '',
    //   numero: '',
    //   complemento: '',
    //   ponto_referencia: '',
    //   bairro: '',
    //   uf: '',
    //   cidade: '',
    //   cep: ''
    // },
    contato = '',
    enderecos = [],
    telefones = [],
    emails = [],
    id_colaborador = null,
    versao_imp = 0
  ) {
    this.id_cliente = id_cliente;
    this.numero_cliente = numero_cliente;
    this.tipo_pessoa = tipo_pessoa;
    this.razao_social = razao_social;
    this.nome_fantasia = nome_fantasia;
    this.cpf_cnpj = cpf_cnpj;
    this.inscricao_municipal = inscricao_municipal;
    this.rg_ie = rg_ie;
    // this.endereco = endereco;
    this.contato = contato;
    this.enderecos = enderecos;
    this.telefones = telefones;
    this.emails = emails;
    this.id_colaborador = id_colaborador;
    this.versao_imp = versao_imp;
  }
}